import gql from 'graphql-tag';
import WaveTab from './fragmentWaveTab';

export default gql`
  fragment OrderRow on Order {
    id
    type
    skId
    skOrderNum
    skCustRef
    pickDate
    truck
    stop
    routed
    publishedAt
    dtUploadStatus
    didRollover
    rolloversCount

    status
    qty
    cases
    bottles
    qtyFormatted
    skus
    casesShort
    bottlesShort
    orderType
    category
    direction
    zone
    region
    account
    accountDetails {
      transactionUser
      updatedAt
    }
    orderNotes
    deliveryNotes
    deliveryDays {
      mondayStart
      mondayEnd
      tuesdayStart
      tuesdayEnd
      wednesdayStart
      wednesdayEnd
      thursdayStart
      thursdayEnd
      fridayStart
      fridayEnd
      exclusionStart
      exclusionEnd
      deliveryWindowsEmpty
    }
    address
    phone
    cod
    invoices {
      skId
      owner
      invoiceNum
      invoiceRef
      isCustom
    }

    boxesRequested
    boxesShort
    boxesScanned
    publishedAt

    # picks {
    #   id
    #   type
    #   qty
    # }

    isCommonCarrier
    requestedCommonCarrier
    trackersSummary
    trackers {
      id
      status
      carrier
      carrierService
      code
      url
      labelUrl
    }

    routedBy
    dispatchTrackDistributionCenter

    wave {
      ...WaveTab
    }
  }
  ${WaveTab}
`;



// WEBPACK FOOTER //
// ./src/queries/fragmentOrderRow.js